export enum PermissionLevelEnum {
  NONE = "NONE",
  PARTIAL = "PARTIAL",
  FULL = "FULL",
}
